<template>
  <div class="survey">
    <form method="POST" action="/survey">
        <survey-question
            v-for="(question, index) in questions"
            :key="question.id"
            v-show="index == current"
            :question="question"
            :isLast="current == (questions.length - 1)"
            @goNext="goNext"/>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';
import SurveyQuestion from '../components/SurveyQuestion';

export default {
    name: 'Survey',
    components: {
        SurveyQuestion
    },
    data: function () {
        return {
            questions: [],
            current: 0
        }
    },
    mounted: async function () {
        const res = await Axios.get('/api/survey');
        this.questions = res.data.questions;
    },
    methods: {
        goNext: function() {
            this.current = Math.min(this.current + 1, this.questions.length - 1);
        }
    }
}
</script>